module.exports = __webpack_public_path__ + "static/media/8.51488d03.png";